import { useEffect } from "react";
import ReactDOM from "react-dom";
import styles from "./Modal.module.css";

export default function Modal({ type, show, onShow, onClose, children }) {
  // Call onShow
  useEffect(() => {
    if (onShow) {
      onShow();
    }
  }, [onShow]);

  useEffect(() => {
    const closeModal = (e) => {
      if (e.key === "Escape") {
        onClose(e);
      }
    };

    if (show) {
      window.addEventListener("keydown", closeModal);
      return () => {
        window.removeEventListener("keydown", closeModal);
      };
    }
  }, [show, onClose]);

  // Set Content
  const modalStyle =
    type === "full" ? `${styles.modal} ${styles.modalFull}` : styles.modal;

  const content = (
    <div className={styles.modalWrapper}>
      <div className={styles.modalBackground} onClick={onClose}></div>
      <div className={modalStyle}>{children}</div>
    </div>
  );

  // Render Portal
  if (!show) {
    return null;
  }

  return ReactDOM.createPortal(
    content,
    document.getElementById("modal-container")
  );
}
